import { GcsFile } from "@zickko/shared";
import { ValidationResult } from "nutso";
import { clientConfig } from "../config/clientConfig";
import { FileInput } from "../elements/FileInput";
import { FormItemContainer, FormItemProps } from "./FormItemContainer";

type Props = FormItemProps<GcsFile> & {
  value?: GcsFile;
  gcsBucket: string;
  gcsFolder: string;
  onChange: (value?: GcsFile) => void;
  validation?: ValidationResult;
  dataCy?: string;
  onClear?: () => void;
};

export const FormFileUpload = (props: Props) => {
  //
  const renderPreview = () => {
    const { value, gcsBucket } = props;
    if (!value || !value.path) return null;
    const gcsUrl = `${clientConfig.gcsBaseUrl}/${gcsBucket}/${value.path}`;
    return (
      <div className="file-download-link">
        <span>Preview: </span>
        <a href={gcsUrl} target="_blank">
          Click here
        </a>
      </div>
    );
  };

  const { gcsBucket, gcsFolder, onChange, value: image, dataCy, onClear } = props;
  const fileExtensions = ["pdf", "PDF"];

  return (
    <FormItemContainer<GcsFile> {...props} additionalClassNames={`form-file-upload ${props.additionalClassNames}`}>
      <FileInput
        allowedFiles={fileExtensions}
        gcsBucket={gcsBucket}
        gcsFolder={gcsFolder}
        onUploadComplete={(fileInfo) => onChange(fileInfo)}
        dataCy={dataCy}
      />
      {renderPreview()}
      {onClear && image && (
        <a className="clear-link" onClick={onClear}>
          Remove
        </a>
      )}
    </FormItemContainer>
  );
};
